import { rockApi, unwrapRockResponse } from "./rockApiClient";

export const rockAdminApi = {
  async getUsers({ page = 1, per_page = 15, search = "" } = {}) {
    const params = { page, per_page };
    if (search) params.search = search;
    const resp = await rockApi.get("/rocks/admin/users", { params });
    return unwrapRockResponse(resp);
    // Returns: { items: [...], objects: { total, per_page, current_page, last_page } }
  },

  async getUserDetail(userId) {
    const resp = await rockApi.get(`/rocks/admin/users/${userId}`);
    return unwrapRockResponse(resp);
    // Returns: { user, synced_at, data: { collections, my_rocks, recent_snaps } }
  }
};
